module.exports = __webpack_public_path__ + "img/Hovl_MagicSword_Iron.ce9e454e.png";